import React, { useState, useEffect } from "react";
import axios from "axios";
import { fetchToken } from "./Auth"; // (Seu helper de autenticação)

// Componente visual para ícones
const FileIcon = ({ mimeType }) => {
  if (mimeType.includes("pdf")) {
    return <i className="fas fa-file-pdf text-danger fa-lg me-2"></i>;
  }
  if (mimeType.includes("word") || mimeType.includes("officedocument")) {
    return <i className="fas fa-file-word text-primary fa-lg me-2"></i>;
  }
  return <i className="fas fa-file fa-lg me-2"></i>;
};

function ModalDocumentos({ projetoId, onClose }) {
  const [documentos, setDocumentos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedFiles, setSelectedFiles] = useState([]); 
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const apiBaseUrl = "/api"; 
  const token = fetchToken();

  const fetchDocumentos = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${apiBaseUrl}/projetocompleto/${projetoId}/documentos`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDocumentos(res.data.Status === "Success" ? res.data.Result : []);
    } catch (err) {
      setError("Erro de rede ao buscar documentos.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentos();
  }, [projetoId]);

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFiles(Array.from(event.target.files));
      setUploadError(null);
    }
  };

  const handleUpload = async () => {
    if (selectedFiles.length === 0) {
      setUploadError("Por favor, selecione pelo menos um arquivo.");
      return;
    }

    setIsUploading(true);
    setUploadError(null);

    const formData = new FormData();


    selectedFiles.forEach((file) => {
      formData.append("files", file);
    });

    try {
      await axios.post(
        `${apiBaseUrl}/projetocompleto/${projetoId}/upload-documento`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      setSelectedFiles([]); 
      document.getElementById("fileInput").value = null; 
      fetchDocumentos(); 
      alert(`${selectedFiles.length} arquivo(s) enviado(s) com sucesso!`);

    } catch (err) {
      console.error(err);
      setUploadError(
        err.response?.data?.Message || "Erro ao enviar arquivos."
      );
    } finally {
      setIsUploading(false);
    }
  };

  const handleDownload = async (docId, docName) => {
    try {
      const res = await axios.get(
        `${apiBaseUrl}/documentos/${docId}/download`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", docName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Erro ao baixar o arquivo.");
    }
  };

  const handleDelete = async (docId) => {
    if (!window.confirm("Tem certeza que deseja excluir este documento?")) {
      return;
    }
    try {
      await axios.delete(`${apiBaseUrl}/documentos/${docId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchDocumentos();
    } catch (err) {
      alert("Erro ao excluir o arquivo.");
    }
  };

  return (
    <div
      className="modal"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Documentos do Projeto</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            
            <div className="card mb-3">
              <div className="card-body">
                <h6 className="card-title">Adicionar Documentos</h6>
                <p className="card-text text-muted small">
                  Segure <strong>Ctrl</strong> ou <strong>Shift</strong> para selecionar vários arquivos.
                  <br />Formatos: .pdf, .doc, .docx (Máx: 100MB total)
                </p>
                
                <div className="input-group">
                  <input
                    type="file"
                    className="form-control"
                    id="fileInput"
                    multiple 
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleUpload}
                    disabled={isUploading || selectedFiles.length === 0}
                  >
                    {isUploading ? (
                      <span className="spinner-border spinner-border-sm" role="status"></span>
                    ) : (
                      <i className="fas fa-upload me-1"></i>
                    )}
                    {selectedFiles.length > 0 
                      ? `Enviar ${selectedFiles.length} Arqs` 
                      : "Enviar"}
                  </button>
                </div>
                
                {uploadError && (
                  <div className="text-danger mt-2 small">{uploadError}</div>
                )}
              </div>
            </div>

            <h6>Documentos Anexados</h6>
            {isLoading ? (
              <div className="text-center p-3">
                <div className="spinner-border" role="status"></div>
              </div>
            ) : error ? (
              <div className="alert alert-danger">{error}</div>
            ) : documentos.length === 0 ? (
              <p className="text-muted text-center p-3">
                Nenhum documento encontrado.
              </p>
            ) : (
              <ul className="list-group">
                {documentos.map((doc) => (
                  <li
                    key={doc.id}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div className="text-truncate" style={{maxWidth: "80%"}}>
                      <FileIcon mimeType={doc.tipo_mime} />
                      <span
                        className="fw-bold"
                        style={{ cursor: "pointer", color: "#0d6efd" }}
                        onClick={() => handleDownload(doc.id, doc.nome_original)}
                        title="Clique para baixar"
                      >
                        {doc.nome_original}
                      </span>
                      <br />
                      <small className="text-muted ms-4">
                        Data: {doc.data_upload}
                      </small>
                    </div>
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleDelete(doc.id)}
                      title="Excluir documento"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalDocumentos;